import { Chip, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../Translations';

function EmptyActivityComponent() {
  return (
    <Chip
      className="justify-center flex-col h-36 mt-4 border-dotted border-gray-500 bg-white border-2"
      color="slate-gray"
    >
      <Typography variant="bodyMedium" fontWeight="bold" color="dark">
        <T kind="No activity yet" />
      </Typography>
      <Typography variant="caption" className="mt-2" color="dark">
        <T kind="Your data will appear here when it is available." />
      </Typography>
    </Chip>
  );
}

export default observer(EmptyActivityComponent);
